import { Injectable } from '@angular/core';
import { TranslateService } from '@galaxy/lexicon';
import { ActivityInterface, WorkflowStepInterface } from '@vendasta/automata';
import { Observable } from 'rxjs';
import { ActivityTableEntry, AutomationDisplayService, NodeData } from '../../common/automation-display.service';
import { SendNotificationDisplayService } from '../send-notification-common/send-notification-display.service';

@Injectable({ providedIn: 'root' })
export class SendNotificationCustomersService extends AutomationDisplayService {
  constructor(
    protected readonly translateService: TranslateService,
    protected readonly commonNotificationDisplayService: SendNotificationDisplayService,
  ) {
    super();
  }

  getActivityColumn(_namespace: string, activity: ActivityInterface): ActivityTableEntry {
    const activityData = activity?.activityData ? JSON.parse(activity.activityData) : {};
    const userIds = activityData?.user_ids || [];

    return this.tableEntry(this.commonNotificationDisplayService.getActivityTitle(userIds), this.emptyBody());
  }

  getAutomationNodeData(
    _namespace: string,
    _step: WorkflowStepInterface,
    _isWaitUntilNode: boolean,
  ): Observable<NodeData> {
    return this.nodeDisplayData(
      this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATIONS.ACTIONS.TO_ALL_ACCOUNT_USERS'),
      this.noValidationErrorsDetected(),
    );
  }
}
